<template>
  <div class="relative h-screen overflow-hidden flex items-center justify-center px-4">
    <div class="absolute inset-0 w-full h-full z-0">
      <AmbientFabricBackground :settings="{ class: 'w-full h-full' }" />
    </div>
    <div class="relative z-10 flex flex-col gap-8 bg-white rounded-md shadow-md p-8 w-full max-w-md max-h-screen overflow-auto">
      <!-- Logo -->
      <h2 class="text-xl font-bold flex items-center mb-6">
        <Logo />
      </h2>

      <div v-if="step === 1" class="p-4 bg-accent border rounded-md">
        <h4 class="font-semibold">Check your Inbox!</h4>
        <h4 class="font-normal text-dark-green">A link to reset your password has been emailed to you.</h4>
      </div>

      <!-- Dynamic Titles -->
      <div class="flex flex-col gap-8">
        <div class="flex flex-col gap-2">
          <h2 class="font-semibold text-primary font-archivo mb-1">{{ title }}</h2>
          <p class="font-sm text-primary font-archivo mb-6">{{ subtitle }}</p>
        </div>
        <!-- Slot: Login Form -->
        <slot name="form" />

        <!-- Slot: Custom buttons or links -->
        <slot name="footer" />
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import Logo from "../../assets/icons/logo.svg";
import { AmbientFabricBackground } from '@shopexperts/shared';

defineProps<{
  title: string
  subtitle: string
  step: number
}>()
</script>
